import React from 'react';
import Validation from 'react-validation';
import validator from '../../../utils/validator';

export default class SubmitInfo extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {
            email: null,
            firstName: null,
            lastName: null,
            selected: false
        }
        this.handleSubmit = this.handleSubmit.bind();
    }


    componentWillReceiveProps(next){
        let list = this.props.content.filter( e => e.selected == true );
        let profiles = [];
        //Reset
        this.setState({ selected: false });

        list.map((profile) => {
            profile.profiles.map( data => {
                if(data.selected){
                    profiles.push(data);
                }
            })
        })

        if(profiles.length > 0 ){
            this.setState({ selected: true })
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.submitEmail(this.state)
    }

    onChange = (e) => {

        let field = e.target.name;
        this.setState({ [field]: e.target.value}, () => {
            //console.log( this.state)
        })
    }

    render() {
        let { selected } = this.state;
        let content = null;
        let template = () => {
            return (
                <Validation.components.Form ref='form' onSubmit={(e) => this.handleSubmit(e)}>
                    <h3>Ready!</h3>
                    <p>Please send fill the blanks to get a full description of your team’s profile.</p>
                    <div className="main">
                        <div className="row">
                            <div className="col-6">
                                <Validation.components.Input 
                                    ref='firstName' 
                                    value='' 
                                    type='text'
                                    placeholder='First Name' 
                                    name='firstName'
                                    onChange={ (e) => this.onChange(e) }
                                    validations={['required']} />
                            </div>
                            <div className="col-6">
                                <Validation.components.Input 
                                    ref='lastName' 
                                    value='' 
                                    type='text'
                                    placeholder='Last Name' 
                                    name='lastName'
                                    onChange={ (e) => this.onChange(e) }
                                    validations={['required']} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <Validation.components.Input 
                                    ref='email' 
                                    value='' 
                                    type='text'
                                    placeholder='Email Address' 
                                    name='email'
                                    onChange={ (e) => this.onChange(e) }
                                    validations={['required', 'email']} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <Validation.components.Button className="btn-submit">Send your Request</Validation.components.Button>
                            </div>
                        </div>
                    </div>
                    <p className="claimer">*The hourly rate price range doesn't include social security, local taxes and fees.</p>
                </Validation.components.Form>
            )
        };

        if(selected){
            content = template();
        }

        return (
            <section>
                {content}
            </section>            
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/build-your-team/views/submitInfo.js